/**
 * @project 中国人群健康大数据平台
 * 
 * @author  Guojun Wang
 * @date    2022-11-21 14:00:00
 **/ 

import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

// 网站顶导
import Header from './layout/Nav';
import { NavDataSource } from './layout/data.source.js';

// 平台首页
import Home from './home';
import About from './about';
import ERROR from './error';

// G2G工具
import G2G from './g2g';

// 科研软件
import GCTA from './software/gcta';
import SMR from './software/smr';
import GSMR from './software/gsmr';
import OSCA from './software/osca';
import THISTLE from './software/thistle';

// fastGWA 数据集
import FastGwa from './data';

// BrainMeta 数据集
import BrainMeta from './meta';

// 登陆鉴权
import Login from './account/login';
import Info from './account/info';
import Signup from './account/signup';
import Password from './account/password';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentDidMount() {

  }
  render() {
    // 以下路由对应页面，不包含顶部导航栏
    const noHeader = ['/g2g', '/login', '/info', 'signup', 'password'];

    return (
      <Router>
        {
          !noHeader.includes(window.location.pathname) ? (
            <Header dataSource={NavDataSource} />
          ) : null
        }

        <Switch>
          {/* 平台首页 */}
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/about" component={About} />

          {/* G2G工具 */}
          {/* <Route exact path="/g2g" component={G2G} /> */}

          {/* 科研软件 */}
          <Route exact path="/software-gcta" component={GCTA} />
          <Route exact path="/software-smr" component={SMR} />
          <Route exact path="/software-gsmr" component={GSMR} />
          <Route exact path="/software-osca" component={OSCA} />
          <Route exact path="/software-thistle" component={THISTLE} />
          
          {/* fastGWA数据集 */}
          <Route exact path="/data" component={FastGwa} />

          {/* BrainMeta数据集 */}
          <Route exact path="/meta" component={BrainMeta} />

          {/* 登陆鉴权 */}
          <Route exact path="/login" component={Login} />
          <Route exact path="/info" component={Info} />
          <Route exact path="/signup" component={Signup} />
          <Route exact path="/password" component={Password} />

          {/* 路由匹配失败兜底逻辑 */}
          <Route exact path="/404" component={ERROR} />
          <Redirect from="*" to="/404" />
        </Switch>
      </Router>
    );
  }
}

export default App;
